module.exports = __webpack_public_path__ + "img/reka-cipta.4cf4bb32.png";